<template>
    <div class="flex w-full flex-col py-2">
        <div class="flex flex-row gap-6 border-b-[1px] border-b-ds-primary-200 pb-2 pt-2">
            <div
                class="flex-1 text-base font-bold text-content-primary"
                :class="{
                    'pl-2 text-base': indentationLevel === 0,
                    'pl-[18px] text-sm': indentationLevel === 1,
                }"
            >
                {{ title || '' }}
                <div
                    v-if="helperText"
                    v-tooltip.right="GEN_IDV_STYLED_TOOLTIP(helperText)"
                    class="inline-block"
                >
                    <font-awesome-icon
                        icon="fa-regular fa-circle-question "
                        size="xs"
                    ></font-awesome-icon>
                </div>
            </div>
            <div
                class="flex w-14 cursor-pointer items-center justify-end pr-1 text-xs text-content-secondary"
                @click="contentExpanded = !contentExpanded"
            >
                <font-awesome-icon
                    v-if="contentExpanded"
                    icon="fa-solid fa-chevron-up"
                    size="sm"
                ></font-awesome-icon>
                <font-awesome-icon
                    v-else
                    icon="fa-solid fa-chevron-down"
                    size="sm"
                ></font-awesome-icon>
            </div>
        </div>

        <div v-if="contentExpanded">
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { GEN_IDV_STYLED_TOOLTIP } from './idv-helper-tooltip.pt';

const contentExpanded = ref(true);

withDefaults(defineProps<{ title?: string; indentationLevel?: number; helperText?: string }>(), {
    indentationLevel: 0,
    helperText: '',
});
</script>
